import { ColDef } from "ag-grid-community";
import { utcDate } from "~utils/Date.ts";

/**
 * Date column type for the ag-grid.
 */
export const DateColumn: ColDef = {
  filter: "agDateColumnFilter",
  floatingFilter: true,
  filterParams: {
    filterOptions: [
      "equals",
      "notEqual",
      "lessThan",
      "lessThanOrEqual",
      "greaterThan",
      "greaterThanOrEqual",
      "inRange",
      "blank",
      "notBlank"
    ]
  },
  valueFormatter(params) {
    if (params.value && params.value != "null") {
      return utcDate(params.value).local().format("DD-MM-YYYY");
    }

    return "-";
  }
};
